(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-gift-finder]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const style = form.querySelector('[data-gift-style]');
      style.disabled = false;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const recipient = form.querySelector('[data-recipient]').value;
        const query = style.value ? `(${recipient}) AND (${style.value})` : recipient;
        const url = new URL(form.action, location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'hide');
        url.searchParams.set('q', query);
        const budget = form.querySelector('[name="filter.v.price.lte"]')?.value;
        if (budget) url.searchParams.set('filter.v.price.lte', budget);
        location.assign(url.href);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
